import { Box, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
    cast?: string[]
}
const CastContainer = ({ cast }: Props) => {
    const { t: translate } = useTranslation()
    const actorStyle = {
        ml: '5px',
    }
    const containerStyle = {
        color: 'gray',
        mt: '20px',
        display: 'flex',
        overflow: 'auto',
    }
    const mappedCastDisplayElements = cast?.map(
        (actor: string, index: number) => (
            <Typography key={index} sx={actorStyle}>
                {actor}
                {index < cast.length - 1 ? ',' : ''}
            </Typography>
        )
    )
    return (
        <Box sx={containerStyle}>
            {translate('cast')}:{mappedCastDisplayElements?.slice(0, 5)}
        </Box>
    )
}

export default CastContainer
